import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useHiddenBodyOverflow } from '../../hooks/useHiddenBodyOverflow';
import { useStores } from '../../stores/useStores';
import Button from '../buttons/Button';

import classes from './UserSnappyGifts.module.scss';

export const UserSnappyGiftsDialog = observer(() => {
  const { t } = useTranslation();
  const { userSnappyGiftsStore, featureManagerStore } = useStores();
  const { selectedSnappyGift } = userSnappyGiftsStore;

  useHiddenBodyOverflow(true);

  if (!selectedSnappyGift) {
    return null;
  }

  const nextDialogHandler = () => {
    const isNextDialog = userSnappyGiftsStore.showNextDialog();
    if (!isNextDialog) {
      featureManagerStore.onDialogFinished('UserSnappyGifts');
    }
  };

  const onCloseHandler = () => {
    userSnappyGiftsStore.closeDialog();
    setTimeout(nextDialogHandler, 500);
  };

  const onClaimHandler = () => {
    window.open(selectedSnappyGift.giftLink, '_blank');
    onCloseHandler();
  };

  return (
    <div className={classes.freeSpinDialogCover}>
      <div className={classes.dialogContent}>
        <div className={classes.closeWrapper}>
          <div onClick={onCloseHandler}>
            <div className={classes.closeBtn}>&times;</div>
          </div>
        </div>
        <div className={classes.widgetParent}>
          <img alt="snappy gift" src={selectedSnappyGift.snappyDialogImageUrl} />
        </div>
        <Button btnType="main" classNameWrapper={classes.btnWrapper} onClick={onClaimHandler}>
          {t('common.buttons.claimNowLowerCase')}
        </Button>
      </div>
    </div>
  );
});
